export default __webpack_public_path__ + "static/media/math.282b45809c9557a85cacb7162a0d78fb.svg";